import React from "react"
import Block from "@bappweb/block"
import Element from "@bappweb/element"
import Image from "@bappweb/image"
import Col from "@bappweb/col"
import Row from "@bappweb/row"
import "../assets/style.scss"

const LandingHeader = () => {
  return (
    <Block type="header" className="landing-header-container landing-header-container-red">
      <Row>
        <Col xs={12} md={10} lg={10} xl={10} mdOffset={1} lgOffset={1} xlOffset={1}>
          <div className="bapp-container">
            <Block className="landing-header-text-wrapper">
              <Block className="landing-header-text">
                <Element type="h1" className="header-text1">
                  {
                    "Beklenmeyen kazalar karşısında kendini ve sevdiklerini maddi kayıplara karşı güvence altına al!"
                  }
                </Element>
                <Element type="p" className="header-text2">
                  {
                    "Ferdi Kaza Sigortası, başınıza gelebilecek kazalar sonucu oluşabilecek kalıcı sakatlık veya yaşam kaybı gibi durumlarda sunduğu teminatlar ile sizi ve sevdiklerinizi finansal olarak güvence altına alır. Ayrıca, tedavi masraflarınızı karşılamanıza yardımcı olur."
                  }
                </Element>
              </Block>
            </Block>

            <Image
              path={"./img/ferdikazasigortalead/ferdi-kaza-sigorta.png"}
              className="landing-header-img"
            />
          </div>
        </Col>
      </Row>
    </Block>
  )
}

export default LandingHeader
